import React from 'react';
import '../styles/ServicesPreview.css';

function ServicesPreview() {
  return (
    <section className="services-preview">
      <div className="container">
        <h2>Our Services</h2>
        <div className="services-grid">
          <div className="service-item">
            <h3>Website Development</h3>
            <p>Custom websites built for your brand, fast, scalable, and SEO-friendly.</p>
          </div>
          <div className="service-item">
            <h3>E-commerce Solutions</h3>
            <p>Launch your online store with Shopify, WooCommerce, or custom platforms.</p>
          </div>
          <div className="service-item">
            <h3>Mobile App Development</h3>
            <p>iOS and Android apps that enhance your customer experience and engagement.</p>
          </div>
          <div className="service-item">
            <h3>Hosting & Domain Services</h3>
            <p>Get reliable hosting, domain management, and website security all in one place.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ServicesPreview;